
            


            <!-- =========Header Content Area=========== -->
            <section>
                <div class="header-content-area">
                    <div class="container">
                        <!--header pattern-->
                        <div class="header-pattern-1">
                            <img src="../../../../assets/img/home/header-pattern-1.png" alt="">
                        </div>
                        <div class="header-pattern-2">
                            <img src="../../../../assets/img/home/header-pattern2.png" alt="">
                        </div>
                        <div class="header-animation-area">
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-12">
                                    <!--header text-->
                                    <div class="intro-text">
                                        <h1 data-aos="slide-right" data-aos-anchor-placement="top-bottom" data-aos-delay="500" data-aos-duration="1200">Save Time and<br>  Boost-up Productivity</h1>
                                        <p data-aos="fade-in" data-aos-anchor-placement="top-bottom" data-aos-delay="1000" data-aos-duration="1200">Well-organized application with impressive speed <br>
                                            is the most extensive and valuable asset for your  <br> <b style="text-transform: uppercase;">start-up or business.</b> </p>
                                        <div class="learnmore" data-aos="fade-in" data-aos-anchor-placement="top-bottom" data-aos-delay="1500" data-aos-duration="1200">
                                            <a [routerLink]="['/contact']"  class="skill-btn">hire us</a>
                                            <!-- <div class="learnmore2">
                                                <a href="https://www.youtube.com/watch?v=IMbG5et2pZw" class="skill-btn-youtube popup-youtube"><i class="far fa-play-circle"></i></a>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                                <!--header artwork-->
                                <div class="header-1-artwork">
                                    <div class="layer">
                                        <img src="../../../../assets/img/home/header-1-artwork.png" alt="">
                                        <!-- <div class="layer-1" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="800" data-aos-duration="1000">
                                            <img src="../../../../assets/img/man-in-board.png" alt="">
                                        </div> -->
                                        <!-- <div class="layer-2" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="800" data-aos-duration="1000">
                                            <img src="../../../../assets/img/man-in-pc.png" alt="">
                                        </div>-->
                                        <div class="layer-3">
                                            <img src="../../../../assets/img/home/spin.png" alt="">
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- =========About Us Area=========== -->
            <section>
                <div class="home-about-area">
                    <div class="container">
                        <div class="row">
                            <!--about image-->
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="home-about-image">
                                    <img src="../../../../assets/img/home/At the office.gif" alt="">
                                </div>
                            </div>
                            <!--about text-->
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="section-heading-1 home-about-text">
                                    <h4>About US</h4>
                                    <h3>Know interesting things</h3>
                                    <p>We provide a secure, scalable, reliable, compatible, interactive, and speedy application with groundbreaking recent technology. 
                                        We also serve intelligence capability with predictable features that enrich the experience of user and consumer. </p>
                                    <div class="section-button">
                                        <a [routerLink]="['/about']" >Read More</a>
                                    </div>
                                    <div class="e-pattern">
                                        <img src="../../../../assets/img/expertise/e-pattern.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- =========Service Area=========== -->
            <section>
                <div class="services-area">
                    <svg id="curve" data-name="layer 1" xmlns="http://www.w3.org/2000/svg" viewbox="0 0 1416.99 174.01">
                        <path class="cls-1" d="M0,280.8S283.66,59,608.94,163.56s437.93,150.57,808,10.34V309.54H0V280.8Z" transform="translate(0 -135.53)" />
                    </svg>
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-5 d-flex align-items-center">
                                <!--service heading text-->
                                <div class="section-heading-2 section-heading-2-p">
                                    <h4>our services</h4>
                                    <h3>Services We provides</h3>
                                    
                                    <div class="section-button">
                                        <a [routerLink]="['/services']">Details</a>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-7">
                                <div class="row">
                                    <!--service box-->
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 d-flex align-items-center">
                                        <div class="single-service" data-aos="fadein" data-aos-anchor-placement="top-bottom" data-aos-delay="100" data-aos-duration="1000">
                                            <div class="service-icon">
                                                <img src="../../../../assets/img/home/srms.png" alt="">
                                            </div>
                                            <div class="service-text">
                                                <h3>Smart Restaurant Management System</h3>
                                                <p>Real time contactless solution</p>
                                            </div>
                                            <div class="servive-p-1">
                                                <img src="../../../../assets/img/service/service-p-1.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 margin-top-sb-30">
                                        <div class="row">
                                            <!--service box-->
                                            <div class="col-xl-12">
                                                <div class="single-service">
                                                    <div class="service-icon">
                                                        <img src="../../../../assets/img/home/websiteDev.png" alt="">
                                                    </div>
                                                    <div class="service-text">
                                                        <h3>Website Development</h3>
                                                        <p>Any varieties of website that you need.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--service box-->
                                            <div class="col-xl-12">
                                                <div class="single-service service-mt-30" data-aos="fadein" data-aos-anchor-placement="top-bottom" data-aos-delay="300" data-aos-duration="1000">
                                                    <div class="service-icon">
                                                        <img src="../../../../assets/img/home/onlineShop.png" alt="">
                                                    </div>
                                                    <div class="service-text">
                                                        <h3>Any Online Shop Solution</h3>
                                                        <p>Coming Soon</p>
                                                    </div>
                                                    <div class="servive-p-2">
                                                        <img src="../../../../assets/img/service/service-p-3.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- =========Portfolio Area=========== -->
            <section>
                <div class="portfolio-area">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6">
                               
                                <div class="section-heading-2 portfolio-pattern">
                              
                                    <h3>Our Technology Stack</h3>
                                    <p>There are some technology stacks mentioned below that we use in our services.</p>
                                    <div class="p-pattern">
                                        <img src="../../../../assets/img/home/p-pattern.png" alt="">
                                    </div>
                                </div>
                            </div>
                            
                            <!-- <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="portfolio-button-area">
                                    <div class="section-button">
                                        <a href="#">view more</a>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                        <div class="row portfolio-item-slider">
                       
                            <div class="single-portfolio-item">
                                <img src="../../../../assets/img/home/angular2.png" alt="">
                                <div class="portfolio-item-content">
                                    <div class="item-icon" style="border: 1px solid grey;">
                                        <a href="https://angular.io/" target="_blank"><i class="fas fa-link"></i></a>
                                    </div>
                                    <div class="item-text">
                                        <h5>Angular</h5>
                                        <p class="fontSize12">Angular is a platform for building mobile and desktop web applications. It is an open-source web application framework led by the Angular Team at <b>Google</b>. </p>
                                    </div>
                                </div>
                            </div>
                       
                            <div class="single-portfolio-item">
                                <img src="../../../../assets/img/home/netcorenew2.png" alt="">
                                <div class="portfolio-item-content">
                                    <div class="item-icon">
                                        <a href="https://dotnet.microsoft.com/" target="_blank"><i class="fas fa-link"></i></a>
                                    </div>
                                    <div class="item-text">
                                        <h5>ASP.NET Core</h5>
                                        <p class="fontSize12">.NET Core is a free and open-source, managed computer software framework for Windows, Linux, and macOS operating systems.The project is developed by <b>Microsoft</b> and released under the MIT License.</p>
                                    </div>
                                </div>
                            </div>
                          
                            <div class="single-portfolio-item">
                                <img src="../../../../assets/img/home/Mysql.png" alt="">
                                <div class="portfolio-item-content">
                                    <div class="item-icon">
                                        <a href="https://www.mysql.com/" target="_blank"><i class="fas fa-link"></i></a>
                                    </div>
                                    <div class="item-text">
                                        <h5 class="fontSize12">MySQL</h5>
                                        <p>MySQL is an open-source relational database management system.It is developed by <b>Oracle</b> Corporation.</p>
                                    </div>
                                </div>
                            </div>
                           
                            <div class="single-portfolio-item">
                                <img src="../../../../assets/img/home/azure.png" alt="">
                                <div class="portfolio-item-content">
                                    <div class="item-icon">
                                        <a href="https://azure.microsoft.com/en-us/overview/what-is-azure/" target="_blank"><i class="fas fa-link"></i></a>
                                    </div>
                                    <div class="item-text">
                                        <h5>Microsoft Azure Cloud</h5>
                                        <p class="fontSize12">Microsoft Azure is an ever-expanding set of cloud services to help your organization meet your business challenges. It is developed by <b>Microsoft</b></p>
                                    </div>
                                </div>
                            </div>
                       
                            <div class="single-portfolio-item">
                                <img src="../../../../assets/img/home/PostGreUp.png" alt="">
                                <div class="portfolio-item-content">
                                    <div class="item-icon">
                                        <a href="https://www.postgresql.org/" target="_blank"><i class="fas fa-link"></i></a>
                                    </div>
                                    <div class="item-text">
                                        <h5>PostgreSQL</h5>
                                        <p class="fontSize12">PostgreSQL, also known as Postgres, is a free and open-source relational database management system emphasizing extensibility and SQL compliance.</p>
                                    </div>
                                </div>
                            </div>
                           
                            <div class="single-portfolio-item">
                                <img src="../../../../assets/img/home/sql server.png" alt="">
                                <div class="portfolio-item-content">
                                    <div class="item-icon">
                                        <a href="https://www.microsoft.com/en-us/sql-server" target="_blank"><i class="fas fa-link"></i></a>
                                    </div>
                                    <div class="item-text">
                                        <h5>Microsoft SQL Server</h5>
                                        <p class="fontSize12">Microsoft SQL Server is a relational database management system developed by <b>Microsoft</b> .</p>
                                    </div>
                                </div>
                            </div>
                           
                            <div class="single-portfolio-item">
                                <img src="../../../../assets/img/home/React.png" alt="">
                                <div class="portfolio-item-content">
                                    <div class="item-icon">
                                        <a href="https://reactjs.org/" target="_blank"><i class="fas fa-link"></i></a>
                                    </div>
                                    <div class="item-text">
                                        <h5>React</h5>
                                        <p class="fontSize12">React is an open-source JavaScript library for building user interfaces. It is maintained by <b>Facebook</b>  and a community of individual developers and companies. </p>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="single-portfolio-item">
                                <img src="../../../../assets/img/home/Docker.png" alt="">
                                <div class="portfolio-item-content">
                                    <div class="item-icon">
                                        <a href="https://www.docker.com/" target="_blank"><i class="fas fa-link"></i></a>
                                    </div>
                                    <div class="item-text">
                                        <h5>Docker</h5>
                                        <p class="fontSize12">Docker is a set of platform as a service products that uses OS-level virtualization to deliver software in packages called containers. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="single-portfolio-item">
                                <img src="../../../../assets/img/home/xamarin.png" alt="">
                                <div class="portfolio-item-content">
                                    <div class="item-icon">
                                        <a href="https://dotnet.microsoft.com/apps/xamarin" target="_blank"><i class="fas fa-link"></i></a>
                                    </div>
                                    <div class="item-text">
                                        <h5>Xamarin</h5>
                                        <p class="fontSize12">Xamarin. Forms is an open source mobile UI framework from <b>Microsoft</b> for building iOS, Android, & Windows apps with . NET from a single shared codebase.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="single-portfolio-item">
                                <img src="../../../../assets/img/home/KuberNetes.png" alt="">
                                <div class="portfolio-item-content">
                                    <div class="item-icon">
                                        <a href="https://kubernetes.io/" target="_blank"><i class="fas fa-link"></i></a>
                                    </div>
                                    <div class="item-text">
                                        <h5>Kubernetes</h5>
                                        <p class="fontSize12">Kubernetes is an open-source container-orchestration system for automating computer application deployment, scaling, and management. It was originally designed by <b>Google</b> and is now maintained by the Cloud Native Computing Foundation.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- =========Expertise Area=========== -->
            <section>
                <div class="expertise-area">
                    <div class="container">
                        <div class="row">
                            <!--expertise image-->
                            <div class="col-xl-6 col-lg-6 col-md-6">
                                <div class="expertise-image">
                                    <img src="../../../../assets/img/expertise/EC2.png" alt="">
                                </div>
                            </div>
                            <!--expertise heading text-->
                            <div class="col-xl-6 col-lg-6 col-md-6 d-flex align-items-center">
                                <div class="section-heading-1 home-expertise-text">
                                    <h4>Experties</h4>
                                    <h3>Cloud-Based Solution</h3>
                                    <p>Every service that we provide is a cloud-based secure, scalable, and robust system that reaches your business to the next level.</p>
                                    <!-- <div class="section-button">
                                        <a href="#">get quote</a>
                                    </div> -->
                                    <div class="e-pattern">
                                        <img src="../../../../assets/img/expertise/e-pattern.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- =========Client Area=========== -->
            <!-- <div class="client-area">
                <div class="container">
                    <div class="row d-flex align-items-center">
                        
                        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                            <div class="single-client-img">
                                <img src="../../../../assets/img/client/1.png" alt="">
                            </div>
                        </div>
                       
                        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                            <div class="single-client-img">
                                <img src="../../../../assets/img/client/2.png" alt="">
                            </div>
                        </div>
                        
                        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                            <div class="single-client-img">
                                <img src="../../../../assets/img/client/3.png" alt="">
                            </div>
                        </div>
                       
                        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                            <div class="single-client-img">
                                <img src="../../../../assets/img/client/4.png" alt="">
                            </div>
                        </div>
                     
                        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                            <div class="single-client-img">
                                <img src="../../../../assets/img/client/5.png" alt="">
                            </div>
                        </div>
                        
                        <div class="col-xl-2 col-lg-2 col-md-4 col-sm-4 col-6">
                            <div class="single-client-img">
                                <img src="../../../../assets/img/client/6.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- =========Counter Area=========== -->
            <!-- <section>
                <div class="main-counter-area">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-6">
                                <div class="row counter-area-small">
                                   
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 single-count-item-mb">
                                        <div class="single-count-area"><img src="../../../../assets/img/counter/manager.png" alt=""> <br> <span class="counter">1800</span><span>+</span>
                                            <p>projects</p>
                                        </div>
                                    </div>
                                   
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 single-count-item-mb">
                                        <div class="single-count-area"><img src="../../../../assets/img/counter/chart.png" alt=""><br><span class="counter">1000</span><span>+</span>
                                            <p>clients</p>
                                        </div>
                                    </div>
                                   
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                        <div class="single-count-area"> <img src="../../../../assets/img/counter/coin.png" alt=""> <br> <span class="counter">150</span><span>k+</span>
                                            <p>profit</p>
                                        </div>
                                    </div>
                                   
                                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 margin-top-sb-30">
                                        <div class="single-count-area"> <img src="../../../../assets/img/counter/theme.png" alt=""> <br> <span class="counter">500</span><span>+</span>
                                            <p>coming</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                           
                            <div class="col-xl-6 d-flex align-items-center">
                                <div class="section-heading-1 home-counter-text">
                                    <h4>Summary</h4>
                                    <h3>Achivement we have</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Impedit eos iste accusamus ipsum temporibus officia assumenda, in tempora expedita aperiam magnam voluptatum culpa hic dolore molestiae eius magni! Accusantium optio impedit neque assumenda autem exercitationem aliquam cupiditate, quaerat iusto vero, necessitatibus sapiente accusamus blanditiis voluptas aperiam deleniti alias.</p>
                                    <div class="section-button">
                                        <a href="#">Request quote</a>
                                    </div>
                                    <div class="e-pattern">
                                        <img src="../../../../assets/img/expertise/e-pattern.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
            <!-- =========Testimonial Area=========== -->
            <!-- <section>
                <div class="testimonial-area">
                    <div class="container">
                        <div class="row">
                           
                            <div class="col-xl-12">
                                <div class="section-heading-3">
                                    <h4>Testimonial</h4>
                                    <h3>What people say</h3>
                                </div>
                            </div>
                        </div>
                        <div class="row testimonial-slider">
                            
                            <div class="single-testimonial d-flex align-items-center">
                                <div class="left-content">
                                    <div class="quotation">
                                        <img src="../../../../assets/img/client/qoute.png" alt="">
                                    </div>
                                    <div class="testi-slider-text">
                                        <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis labore sapiente iste doloribus ducimus unde, veniam inventore eius aliquid ab ipsa laborum, architecto ea ut. Eligendi, aut delectus quia nemo animi.</p>
                                        <h4>Gary Love</h4>
                                        <h5>CEO,XYZ.com</h5>
                                    </div>
                                    <div class="right-quote">
                                        <img src="../../../../assets/img/client/right-quote.png" alt="">
                                    </div>
                                </div>
                                <div class="right-content">
                                    <div class="testimonial-img">
                                        <img src="../../../../assets/img/client/testimonial-1.jpg" alt="">
                                    </div>
                                </div>
                            </div>
                          
                            <div class="single-testimonial d-flex align-items-center">
                                <div class="left-content">
                                    <div class="quotation">
                                        <img src="../../../../assets/img/client/qoute.png" alt="">
                                    </div>
                                    <div class="testi-slider-text">
                                        <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis labore sapiente iste doloribus ducimus unde, veniam inventore eius aliquid ab ipsa laborum, architecto ea ut. Eligendi, aut delectus quia nemo animi.</p>
                                        <h4>Gary Done</h4>
                                        <h5>CEO,XYZ.com</h5>
                                    </div>
                                    <div class="right-quote">
                                        <img src="../../../../assets/img/client/right-quote.png" alt="">
                                    </div>
                                </div>
                                <div class="right-content">
                                    <div class="testimonial-img">
                                        <img src="../../../../assets/img/client/testimonial-2.jpg" alt="">
                                    </div>
                                </div>
                            </div>
                          
                            <div class="single-testimonial d-flex align-items-center">
                                <div class="left-content">
                                    <div class="quotation">
                                        <img src="../../../../assets/img/client/qoute.png" alt="">
                                    </div>
                                    <div class="testi-slider-text">
                                        <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officiis labore sapiente iste doloribus ducimus unde, veniam inventore eius aliquid ab ipsa laborum, architecto ea ut. Eligendi, aut delectus quia nemo animi.</p>
                                        <h4>Gary Dove</h4>
                                        <h5>CEO,XYZ.com</h5>
                                    </div>
                                    <div class="right-quote">
                                        <img src="../../../../assets/img/client/right-quote.png" alt="">
                                    </div>
                                </div>
                                <div class="right-content">
                                    <div class="testimonial-img">
                                        <img src="../../../../assets/img/client/testimonial-3.jpg" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
            <!-- =========Pricing Area=========== -->
            <!-- <section>
                <div class="pricing-plan-area">
                    <div class="container">
                        <div class="row">
                           
                            <div class="col-xl-12">
                                <div class="section-heading-3">
                                    <h4>our Pricing</h4>
                                    <h3>latest Pricing plan</h3>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                          
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 margin-bot-sb-30">
                                <div class="single-price">
                                    <div class="price-pattern">
                                        <img src="../../../../assets/img/p-pattern.png" alt="">
                                    </div>
                                    <div class="package">
                                        <h3>Basic</h3>
                                    </div>
                                    <div class="price-qoute">
                                        <p>Lorem ipsum dolor sit amet.</p>
                                        <h2>29$ <span>/ month</span></h2>
                                    </div>
                                    <div class="price-details">
                                        <ul>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Stock images videos.</li>
                                        </ul>
                                    </div>
                                    <div class="price-button">
                                        <a href="#">Get Services</a>
                                    </div>
                                </div>
                            </div>
                          
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                                <div class="single-price active-s">
                                    <div class="price-pattern">
                                        <img src="../../../../assets/img/p-pattern.png" alt="">
                                    </div>
                                    <div class="package active-h">
                                        <h3>Standard</h3>
                                    </div>
                                    <div class="price-qoute">
                                        <p>Lorem ipsum dolor sit amet.</p>
                                        <h2>59$ <span>/ month</span></h2>
                                    </div>
                                    <div class="price-details">
                                        <ul>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Stock images videos.</li>
                                        </ul>
                                    </div>
                                    <div class="price-button active-b">
                                        <a href="#">Get Services</a>
                                    </div>
                                </div>
                            </div>
                           
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 margin-top-sb-30 margin-top-lb-30">
                                <div class="single-price">
                                    <div class="price-pattern">
                                        <img src="../../../../assets/img/p-pattern.png" alt="">
                                    </div>
                                    <div class="package">
                                        <h3>Premium</h3>
                                    </div>
                                    <div class="price-qoute">
                                        <p>Lorem ipsum dolor sit amet.</p>
                                        <h2>99$ <span>/ month</span></h2>
                                    </div>
                                    <div class="price-details">
                                        <ul>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Lorem ipsum dolor sit.</li>
                                            <li><i class="far fa-check-circle"></i> Stock images videos.</li>
                                        </ul>
                                    </div>
                                    <div class="price-button">
                                        <a href="#">Get Services</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
            <!-- =========Blog Area=========== -->
            <!-- <section>
                <div class="home-blog-area">
                    <div class="container">
                        <div class="row">
                           
                            <div class="col-xl-12">
                                <div class="section-heading-3">
                                    <h4>Our Blogs</h4>
                                    <h3>Latest Blogs</h3>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                                <div class="home-single-blog">
                                    <div class="s-blog-image">
                                        <img src="../../../../assets/img/blog/1.jpg" alt="">
                                        <div class="blog-post-date">
                                            <span>08 jun</span>
                                        </div>
                                    </div>
                                    <div class="s-blog-content">
                                        <h4>Marketing Experties</h4>
                                        <p>Lorem ipsum dolor sit amet adipisicing elit. Sunt enim, quas et libero excepturi!</p>
                                        <a href="#">Read More</a>
                                    </div>
                                </div>
                            </div>
                          
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 margin-top-sb-30">
                                <div class="home-single-blog">
                                    <div class="s-blog-image">
                                        <img src="../../../../assets/img/blog/3.png" alt="">
                                        <div class="blog-post-date">
                                            <span>09 aug</span>
                                        </div>
                                    </div>
                                    <div class="s-blog-content">
                                        <h4>design Experties</h4>
                                        <p>Lorem ipsum dolor sit amet adipisicing elit. Sunt enim, quas et libero excepturi!</p>
                                        <a href="#">Read More</a>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 margin-top-sb-30 margin-top-lb-30">
                                <div class="home-single-blog">
                                    <div class="s-blog-image">
                                        <img src="../../../../assets/img/blog/2.png" alt="">
                                        <div class="blog-post-date">
                                            <span>12 jul</span>
                                        </div>
                                    </div>
                                    <div class="s-blog-content">
                                        <h4>SEO Experties</h4>
                                        <p>Lorem ipsum dolor sit amet adipisicing elit. Sunt enim, quas et libero excepturi!</p>
                                        <a href="#">Read More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> -->
        
          
  
        
    
 